var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal-padrao',{ref:"modal-corpo-email",attrs:{"max-width":"80%","titulo":'Corpo do Email',"titulo-cancelar":"Fechar","mostra-botao-salvar":false}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.corpo)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }